import React, { memo } from "react";
import PropTypes from "prop-types";

import MatchedPhraseText from "./MatchedPhraseText";

const overlappingMatchedPhrases = ({ matchedPhrases }) => {
  // Take all matched phrases and join phrases that overlap (via text offsets) into 1 hash of { textStartOffset, textEndOffset, searchPhrases }.
  return (matchedPhrases || []).reduce((overlappedMatchedPhrases, { textStartOffset, textEndOffset, searchPhrase }) => {
    const matchingKey =
      Object.keys(overlappedMatchedPhrases).find((startOffsetKey) => {
        // Find if the current matchedPhrase overlaps any previous phrase.
        const { textStartOffset: startOffset, textEndOffset: endOffset } = overlappedMatchedPhrases[startOffsetKey];
        return (textStartOffset >= startOffset && textStartOffset <= endOffset) || (textEndOffset >= startOffset && textEndOffset <= endOffset);
      });

    if (matchingKey) {
      // If it overlaps, merge them.
      const { textStartOffset: startOffset, textEndOffset: endOffset, searchPhrases } = overlappedMatchedPhrases[matchingKey];

      const newStartOffset = startOffset > textStartOffset ? textStartOffset : startOffset;
      const newEndOffset = endOffset < textEndOffset ? textEndOffset : endOffset;
      const newSearchPhrases = searchPhrases.concat([searchPhrase]);

      overlappedMatchedPhrases[matchingKey] = { textStartOffset: newStartOffset, textEndOffset: newEndOffset, searchPhrases: newSearchPhrases };
    } else {
      // If it does not overlap, make it its own entry.
      overlappedMatchedPhrases[textStartOffset] = { textStartOffset, textEndOffset, searchPhrases: [searchPhrase] };
    }
    return overlappedMatchedPhrases;
  }, {});
};

const textPieces = ({ text, overlappedMatchedPhrases }) => {
  let i;
  const allTextPieces = [];
  let currentNonMatchedText = "";

  for (i = 0; i < text.length; i++) {
    if (overlappedMatchedPhrases[i.toString()]) {
      // If the current index matches a group of matched phrases, push the current non-matching text and insert a MatchedPhraseText.
      allTextPieces.push(currentNonMatchedText);
      currentNonMatchedText = "";

      const { textStartOffset, textEndOffset, searchPhrases } = overlappedMatchedPhrases[i.toString()];
      allTextPieces.push(<MatchedPhraseText key={textStartOffset} text={text.substring(textStartOffset, textEndOffset + 1)} matchedPhraseStrings={searchPhrases}/>);

      i = textEndOffset;
    } else {
      // The current index doesn't match a group of matched phrases, so continue buffering non-matched text.
      currentNonMatchedText += text[i];
    }
  }
  allTextPieces.push(currentNonMatchedText);

  return allTextPieces;
};

const EventText = ({ text, matchedPhrases }) => {
  return (
    <p className="m-0">
      {textPieces({ text, overlappedMatchedPhrases: overlappingMatchedPhrases({ matchedPhrases }) })}
    </p>
  );
};

EventText.propTypes = {
  text: PropTypes.string.isRequired,
  matchedPhrases: PropTypes.arrayOf(
    PropTypes.shape({
      textStartOffset: PropTypes.number,
      textEndOffset: PropTypes.number,
      searchPhrase: PropTypes.string
    })
  )
};

export default memo(EventText);
